<div class="job-posts placements agreements  margin-top-30px" *canUserAccess="['HL_MI_5']">
  <div class="card skillassest-form">

  </div>
  <div class="card-body padding-top padding-left-0px padding-right-10px">
    <div class="row bk-color-sky">
      <div class="col-md-2"></div>
      <div class="col-md-2 col-12 border-right-left-clr text-align-left padding-right-5px my-profile-form padding-left-3px">
        <div class="row">
          <label class="col-md-2 col-12 margin-bottom-0px font-size-12px color-Assign">Select Branch</label>
          <div class="my-profile-form col-md-10 col-12">


            <CustomDataByRequestType RequestedType="FacilityList" class="form-group Strawfont" ActorCode={{ActorCode}}
                                     (keyChange)="Roleassign($event)"
                                     [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                     required>
            </CustomDataByRequestType>
          </div>

        </div>

      </div>
  
        <div class="col-md-2 col-5 border-right-left-clr text-align-center padding-right-5px my-profile-form padding-left-3px">
          <label class="margin-bottom-0px font-size-12px color-Assign">From</label>
          <div class="date-form  form-group margin-bottom-0px">
            <input class="form-control text-align-center font-size-16px" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                   name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

            <a (click)="d.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>

          </div>



        </div>
        <div class="col-md-2 col-5 border-right-left-clr text-align-center padding-right-5px my-profile-form padding-left-3px">
          <label class="margin-bottom-0px font-size-12px color-Assign">To</label>
          <div class="date-form  form-group margin-bottom-0px">
            <input class="form-control text-align-center font-size-16px" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                   name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

            <a (click)="d1.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>

          </div>



        </div>

        <div class="col-md-2 col-2 padding-right-0px my-profile-form margin-top-auto padding-left-3px">

          <div class="row margin-left-0px margin-right-0px">
            <div class="col-md-3 col-12">
              <button (click)="LoadNewDates()" class="btn float-right font-size-13px actions-btn-prime Go-button margin-right-auto">Go..</button>

            </div>
            <div class="col-md-6 col-10 float-left top-link">
              <a class="nav-link nav-link-hand count-indicator padding-top-8px" (click)="OpenDashboardCustomization()"
                 title="Customize your dashboard">

                <i class="fas fa-cog color-coral"></i>
              </a>

            </div>
          </div>

   
      </div>
     

    </div>
    <div class="row">
    
      <div class="col-md-12 padding-right-15px padding-left-0px" *ngIf="CurrentMisReportCategoriesController" >
       
        <div *ngFor="let l of CurrentMisReportCategoriesController">
          <div class="title-graph wow swing">
            {{l.ReportCategory}}
          </div>
          <dashboard-section [ReportCategory]='l.ReportCategory' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='SelectedFacilityCode' [FacilityName]='SelectedFacilityName'
                             [CanLoadReport]='CanLoadReport'></dashboard-section>

        </div>



      </div>
    

    </div>
  </div>

</div>
 



